import {Layer} from "../../common/layers/layer";
import {
    ExtendedReportClassifiedTimeseriesProcessor,
    ExtendedReportRangedTimeseriesProcessor,
    ExtendedReportValuesAndStatsTimeseriesProcessor,
    ExtendedReportValuesTimeseriesProcessor
} from "../timeseries /TimeseriesProcessor";
import {IndicatorChartTypeEnum, StyleRuleTypeEnum, TimeScaleEnum} from "../../common/enum/enum";

/**
 * Layer for the extended report
 * @extends Layer
 */
class Indicator extends Layer {

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param indicatorConfig {Object} The indicator config
     * @param runtimeConfig {ExtendedReportRuntimeConfig} The report runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(translator, isMobileDevice, indicatorConfig, runtimeConfig, onChangeRuntimeConfig) {
        super(translator, isMobileDevice, undefined, undefined, undefined, indicatorConfig, undefined, undefined, runtimeConfig, onChangeRuntimeConfig, false, undefined, undefined);
    }

    getClassName() {
        return "Indicator";
    }

    add2LayersByTimeTag() {
        return this;
    }

    /**
     * Set this indicator's time scale
     * @param timeScale {string}
     */
    setTimeScale(timeScale) {
        this.runtimeConfig.setIndicatorTimeScale(this.getCode(), timeScale)
        this.onChangeRuntimeConfig();
        for (let ls in this.services)
            this.services[ls].setTimeScale(TimeScaleEnum.getForCode(timeScale));
        this.updateName();
    }

    getTimeseriesProcessor(data) {
        const chartType = this.layerConfig.getChartType();
        if (chartType === IndicatorChartTypeEnum.BARS) {
            return new ExtendedReportValuesTimeseriesProcessor(data, this.timeCodeCalculator);
        }
        if (chartType === IndicatorChartTypeEnum.BARS_WITH_LINE || chartType === IndicatorChartTypeEnum.BARS_WITH_LINE_AND_ACCUMULATION) {
            return new ExtendedReportValuesAndStatsTimeseriesProcessor(data, this.timeCodeCalculator);
        }
        if (chartType === IndicatorChartTypeEnum.STACKED_BARS) {
            const type = this.getChartStyler().getFirstRuleType();
            if (type === StyleRuleTypeEnum.DISCRETE)
                return new ExtendedReportRangedTimeseriesProcessor(data, this.getChartStyler(), this.timeCodeCalculator);
            if (type === StyleRuleTypeEnum.CLASSIFIED)
                return new ExtendedReportClassifiedTimeseriesProcessor(data, this.getChartStyler(), this.timeCodeCalculator);
        }
    }
}

export {Indicator}